import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@psspl/utils';
const VARIANT_CLASS = {
    primary: 'bg-brand-500 text-white hover:bg-brand-400 active:bg-brand-600 border border-brand-400/40 shadow-sm shadow-brand-900/40',
    secondary: 'bg-surface-raised text-ink-primary hover:bg-surface-hover border border-line-strong',
    ghost: 'bg-transparent text-ink-secondary hover:text-ink-primary hover:bg-surface-raised border border-transparent',
    danger: 'bg-feedback-danger/10 text-feedback-danger hover:bg-feedback-danger/20 border border-feedback-danger/40',
};
const SIZE_CLASS = {
    sm: 'h-8 px-3 text-xs gap-1.5',
    md: 'h-10 px-4 text-sm gap-2',
    lg: 'h-12 px-6 text-base gap-2',
};
const BASE_CLASS = 'inline-flex items-center justify-center rounded-md font-medium tracking-tight ' +
    'transition-colors duration-150 ease-out-standard ' +
    'disabled:cursor-not-allowed disabled:opacity-55';
/**
 * Class recipe for a button-looking element.
 *
 * Use with `react-router` `<Link>` or a plain `<a>` when the target must navigate
 * instead of submit, so the DOM never nests an anchor inside a button.
 */
export function buttonStyles({ variant = 'primary', size = 'md', className, } = {}) {
    return cn(BASE_CLASS, VARIANT_CLASS[variant], SIZE_CLASS[size], className);
}
export function Button({ variant = 'primary', size = 'md', isLoading = false, leadingIcon, className, children, disabled, type = 'button', ...rest }) {
    return (_jsxs("button", { type: type, disabled: disabled === true || isLoading, "aria-busy": isLoading || undefined, className: buttonStyles({ variant, size, className }), ...rest, children: [isLoading ? (_jsx("span", { "aria-hidden": "true", className: "size-3.5 animate-spin rounded-full border-2 border-current border-t-transparent" })) : (leadingIcon), children] }));
}
//# sourceMappingURL=button.js.map